import { render, staticRenderFns } from "./filter-chart.vue?vue&type=template&id=0c85bd0f&scoped=true&"
import script from "./filter-chart.vue?vue&type=script&lang=js&"
export * from "./filter-chart.vue?vue&type=script&lang=js&"
import style0 from "./filter-chart.vue?vue&type=style&index=0&id=0c85bd0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c85bd0f",
  null
  
)

export default component.exports